module.exports = __webpack_public_path__ + "static/img/10.5a46433.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/zh/10.png
// module id = J6lt
// module chunks = 0